import { Injectable } from '@angular/core';
declare var gtag: any;

@Injectable({
    providedIn: 'root'
})

export class AnalyticsService {

    constructor() { }

    setUserId(mobileNumber:any) {
        if (!mobileNumber) return;
        gtag('user_id', mobileNumber);
    }

    sendPageView(pageTitle: string, page_location:string){
        gtag('event', 'page_view', {
            page_title: pageTitle,
            page_location: page_location
        });
    }

    sendEvent(eventName:string, eventParameters:any) {
        gtag('event', eventName, eventParameters);
    }

    sendPageLoadTime() {
        // Feature detects Navigation Timing API support.
        if (window.performance) {
            // Gets the number of milliseconds since page load
            // (and rounds the result since the value must be an integer).
            let timeSincePageLoad = Math.round(performance.now());

            // Sends the timing hit to Google Analytics.
            gtag('event', 'timing_complete', {
                'name': 'track-load',
                'value': timeSincePageLoad,
                'event_category': 'JS Dependencies'
            });
        }
    }


}
